import api from '../lib/api'
import assign from 'lodash.assign'
import login from '@/utils/login'

const name = 'conversion'

export default {
  name,
  namespaced: true,
  state: {
    price: 499, //畅学卡实际价格
    discountPrice: 499, // 畅学卡优惠后的价格
    coupon: "", // 优惠券信息
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async checkLogin () {
      const wpsSid = await login.getWpsSid()

      return wpsSid || login.login()
    },
    // 获取页面相关信息
    async getCounversionInfo ({ commit }) {
      const { data } = await api.activity.getConversionInfo()
      if (data) {
        commit('set', {
          price: data.originalPrice,
          discountPrice: data.discountPrice,
          coupon: data.coupon
        })
      }
    },
    async init ({ dispatch }) {
      console.log('init conversion')
      await dispatch('checkLogin')
      await dispatch('getCounversionInfo')
    }
  }
}
